export default __webpack_public_path__ + "static/profile-pic-9b423797e00aca69365eae5506e19273.png";